import { cn } from '@lib-atria/ui-toolkit';
import { TextLayout } from '../text';

export function AppointmentsCardTitle({ title }: { title: string }) {
  return <h1 className={cn(TextLayout.callout3, 'text-forest-100 text-center')}>{title}</h1>;
}
